import { render, staticRenderFns } from "./remarkInfo.vue?vue&type=template&id=19aff433&scoped=true&"
import script from "./remarkInfo.vue?vue&type=script&lang=js&"
export * from "./remarkInfo.vue?vue&type=script&lang=js&"
import style0 from "./remarkInfo.vue?vue&type=style&index=0&id=19aff433&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aff433",
  null
  
)

export default component.exports